import axiosIns from '@/api/axios';

export const GET_ALL_DATA = (args) => {
	return axiosIns.get('/users/all', args);
};

export const GET_ALL_DATA_PAGINATED = (args) => {
	return axiosIns.get('/users?' + args);
};

export const DETAIL_DATA = (args) => {
	return axiosIns.get(`/users/${args.id}`);
};

export const ADD_DATA = (args) => {
	return axiosIns.post('/users', args);
};

export const UPDATE_DATA = (args) => {
	return axiosIns.put(`/users/${args.id}`, args);
};

export const DELETE_DATA = (id) => {
	return axiosIns.delete(`/users/${id}`);
};
